import { DateTime } from "luxon";
import { camelCase, startCase } from "lodash";

export const stringDateToISODate = (date?: string) => (date ? DateTime.fromISO(date).toFormat("MM/dd/yyyy") : date);

export const prettyPrintAge = (birthDate?: string) => (birthDate ? prettyPrintTimespan(birthDate, DateTime.now().toISO()) : birthDate);

export const prettyPrintTimespan = (start: string, end: string) => {
	const s = DateTime.fromISO(start);
	const e = DateTime.fromISO(end);
	//
	let days = Math.floor(e.diff(s, ["days"]).days);
	if (days < 28) return `${days} dy`;
	//
	let weeks = Math.floor(e.diff(s, ["weeks"]).weeks);
	if (weeks < 21) return `${weeks} wk`;
	//
	let months = Math.floor(e.diff(s, ["months"]).months);
	if (months < 12) return `${months} mo`;
	//
	let span = e.diff(s, ["years", "months"]);
	let years = Math.floor(span.years!);
	months = Math.floor(span.months!);
	if (months === 12) return "1 yr";
	if (months < 1) return `${years} yr`;
	return `${years} yr, ${months} mo`;
};

/**
 *
 * @param value Unit value
 * @param units Unit Type e.g., Min, Hour, Day
 * @returns formatted string constructed from value and units
 * Example usage:
 * formatUnits(0, "min") = < 1 min
 * formatUnits(1, "min") = 1 min
 * formatUnits(45, "min") = 45 mins
 */
export const formatUnits = (value: number, units: string) => {
	if (value < 1) {
		return `< 1 ${units}`;
	} else if (value == 1) {
		return `1 ${units}`;
	} else {
		return `${value} ${units}s`;
	}
};

/**
 * Serialized pascal object array to camel case
 * @param obj data array of Pascal Case formatting
 */
export const pascalizeKeys = (obj: any): any => {
	if (obj === null || obj === undefined) return undefined;
	if (Array.isArray(obj)) return obj.map(v => pascalizeKeys(v));
	if (obj.constructor === Object) {
		return Object.keys(obj).reduce(
			(result, key) => ({
				...result,
				[toPascalCase(key)]: pascalizeKeys(obj[key]),
			}),
			{}
		);
	}
	return obj;
};

const toPascalCase = (str: string) => startCase(camelCase(str)).replace(/ /g, "");

export const decimalToPercentage = (val?: number) => (val ? Math.round(val * Math.pow(10, 4)) / Math.pow(10, 2) : val);

/** Using luxon DateTime.TIME_SIMPLE to format string date from "2024-03-21T09:00:00" to "09:00 AM" */
export const getTimeFromDateString = (date: string) => {
	const dt = DateTime.fromISO(date);
	return dt.toLocaleString(DateTime.TIME_SIMPLE);
};
